<template>
  <div class="container">
    <div class="item">
      <div class="title">温度记录</div>
      <Echarts :echartsOption="echartsOption1" ref="echartsOption1" />
    </div>
    <div class="item">
      <div class="title">湿度记录</div>
      <Echarts :echartsOption="echartsOption2" ref="echartsOption2" />
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
export default {
  props: ['warningId', 'currentTime'],
  data() {
    return {
      echartsOption1: {
        grid: {
          top: '10%',
          left: '5%',
          containLabel: true,
          right: '10px'
        },
        dataZoom: {
          type: 'inside',
          show: true,
          realtime: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
            label: {
              backgroundColor: '#505765'
            }
          },
          formatter: params => {
            return (
              '<p>' +
              params[0].marker +
              params[0].name +
              '</p>' +
              '<p style="text-align: center">' +
              params[0].value +
              '℃</p>'
            );
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: { color: '#CEDBEF' }
          },
          axisLabel: {
            color: '#999999'
          }
        },
        yAxis: {
          name: '℃',
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: { color: '#CEDBEF' }
          },
          min: 'dataMin',
          max: 'dataMax'
        },
        series: [
          {
            data: [],
            type: 'line',
            itemStyle: {
              color: ({ data }) => {
                if (data.isUnnormal) {
                  return 'red';
                } else {
                  return '#386CE2';
                }
              },
              borderWidth: 2
            },
            lineStyle: {
              color: '#386CE2'
            },
            symbol: 'circle',
            symbolSize: 8,
            markLine: {
              data: [],
              lineStyle: {
                type: 'solid',
                color: 'red'
              },
              silent: true,
              label: {
                formatter: ({ value, dataIndex, data }) => {
                  const valueUnit = `${value}℃`;
                  return data.type === 'down'
                    ? `温度下限${valueUnit}`
                    : `温度上限${valueUnit}`;
                },
                show: true,
                position: 'middle'
              }
            }
          }
        ]
      },
      echartsOption2: {
        grid: {
          top: '10%',
          left: '5%',
          containLabel: true,
          right: '5%'
        },
        dataZoom: {
          type: 'inside',
          show: true,
          realtime: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
            label: {
              backgroundColor: '#505765'
            }
          },
          formatter: params => {
            return (
              '<p>' +
              params[0].marker +
              params[0].name +
              '</p>' +
              '<p style="text-align: center">' +
              params[0].value +
              '%</p>'
            );
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: { color: '#CEDBEF' }
          },
          axisLabel: {
            color: '#999999'
          },
          rotate: '20'
        },
        yAxis: {
          name: '%',
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          splitLine: {
            lineStyle: { color: '#CEDBEF' }
          },
          min: 'dataMin',
          max: 'dataMax'
        },
        series: [
          {
            data: [],
            type: 'line',
            itemStyle: {
              color: ({ data }) => {
                if (data.isUnnormal) {
                  return 'red';
                } else {
                  return '#386CE2';
                }
              },
              borderWidth: 2
            },
            lineStyle: {
              color: '#386CE2'
            },
            symbol: 'circle',
            symbolSize: 8,
            markLine: {
              data: [],
              lineStyle: {
                type: 'solid',
                color: 'red'
              },
              silent: true,
              label: {
                formatter: ({ dataIndex, value, data }) => {
                  const valueUnit = `${value}%`;
                  return data.type === 'down'
                    ? `湿度下限${valueUnit}`
                    : `湿度上限${valueUnit}`;
                },
                show: true,
                position: 'middle'
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$request({
        url: 'rest/riskwarning/detail/tempList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 100000
            },
            params: { warningId: this.warningId }
          })
        }
      }).then(res => {
        const xData = [];
        const y1Data = [];
        const y1DataValue = [];
        const y2Data = [];
        const y2DataValue = [];
        const tempDownLimit = parseFloat(res.limitMap.tempDownLimit).toFixed(2);
        const tempUpLimit = parseFloat(res.limitMap.tempUpLimit).toFixed(2);
        const humidityDownLimit = parseFloat(
          res.limitMap.humidityDownLimit
        ).toFixed(2);
        const humidityUpLimit = parseFloat(
          res.limitMap.humidityUpLimit
        ).toFixed(2);
        // const tempMarkArea = [];
        // const humMarkArea = [];
        // let tempAre = [];
        // let humAre = [];
        // const list = res.list;
        // for (let i = 0; i < list.length; i++) {
        //   // 温度异常
        //   if (list[i].exception_type === '1' && tempAre.length === 0) {
        //     tempAre[0] = { xAxis: list[i].gen_time };
        //   }
        //   if (i + 1 < list.length) {
        //     if (list[i + 1].exception_type === '0' && tempAre.length !== 0) {
        //       tempAre[1] = { xAxis: list[i].gen_time };
        //       tempMarkArea.push(tempAre);
        //       tempAre = [];
        //     }
        //   } else {
        //     tempMarkArea.push(tempAre);
        //     tempAre = [];
        //   }

        //   // 湿度异常
        //   if (list[i].exception_type === '2' && humAre.length === 0) {
        //     humAre[0] = { xAxis: list[i].gen_time };
        //   }
        //   if (i + 1 < list.length) {
        //     if (list[i + 1].exception_type === '0' && humAre.length !== 0) {
        //       humAre[1] = { xAxis: list[i].gen_time };
        //       humMarkArea.push(humAre);
        //       humAre = [];
        //     }
        //   } else {
        //     humMarkArea.push(humAre);
        //     humAre = [];
        //   }
        // }
        // this.echartsOption1.series[0].markArea.data = tempMarkArea.slice(
        //   0,
        //   tempMarkArea.length - 1
        // );
        // this.echartsOption2.series[0].markArea.data = humMarkArea.slice(
        //   0,
        //   humMarkArea.length - 1
        // );
        this.echartsOption1.series[0].markLine.data = [
          { yAxis: tempDownLimit, type: 'down' },
          { yAxis: tempUpLimit, type: 'up' }
        ];
        this.echartsOption2.series[0].markLine.data = [
          { yAxis: humidityDownLimit, type: 'down' },
          { yAxis: humidityUpLimit, type: 'up' }
        ];

        res.list.forEach(item => {
          xData.push(item.gen_time);
          y1Data.push({
            value: item.temp_value,
            isUnnormal: item.exception_type === '1'
          });
          y2Data.push({
            value: item.humidity_value,
            isUnnormal: item.exception_type === '2'
          });
          y1DataValue.push(parseFloat(item.temp_value));
          y2DataValue.push(parseFloat(item.humidity_value));
        });

        this.echartsOption1.xAxis.data = xData;
        this.echartsOption2.xAxis.data = xData;
        this.echartsOption1.series[0].data = y1Data;
        this.echartsOption2.series[0].data = y2Data;

        const max1 = Math.max.apply(null, y1DataValue);
        const min1 = Math.min.apply(null, y1DataValue);
        if (tempDownLimit > max1) {
          this.echartsOption1.yAxis.max = tempDownLimit;
        } else {
          this.echartsOption1.yAxis.max = 'dataMax';
        }
        if (tempUpLimit < min1) {
          this.echartsOption1.yAxis.min = tempUpLimit;
        } else {
          this.echartsOption1.yAxis.min = 'dataMin';
        }

        const max2 = Math.max.apply(null, y2DataValue);
        const min2 = Math.min.apply(null, y2DataValue);
        if (humidityDownLimit > max2) {
          this.echartsOption2.yAxis.max = humidityDownLimit;
        } else {
          this.echartsOption2.yAxis.max = 'dataMax';
        }
        if (humidityUpLimit < min2) {
          this.echartsOption2.yAxis.min = humidityUpLimit;
        } else {
          this.echartsOption2.yAxis.min = 'dataMin';
        }
      });
    }
  },
  watch: {
    currentTime() {
      this.loadData();
    }
  },
  components: {
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.item
  border 1px solid #ccc
  margin-bottom 20px
  padding 20px
  .title
    font-size 16px
    text-align center
    color #000
    font-weight 700
</style>
